import { useMemo } from 'react';
import { usePersona } from '@/auth/usePersona';
import { useGetRegionConfigQuery } from '@store/api';
import { footerConfig } from '@config/footerConfig';
import type { PrivacyLink } from '@config/footerConfig';

const REGION_NAME = 'NORAM';

/**
 * Spec 097-footer-help-revamp: the footer no longer renders help/support
 * contacts. This hook now only exposes the privacy/policy links. The
 * region-API help-link merging previously housed here lives in
 * `useContactLinks` (introduced in the same spec) for the Help panel.
 *
 * The region-config query is still subscribed to keep the existing prefetch
 * cache warm for `useContactLinks` consumers without duplicate fetches.
 */
export function useFooterConfig(): { privacyLinks: PrivacyLink[] } {
  usePersona();
  useGetRegionConfigQuery(REGION_NAME);

  return useMemo(() => ({ privacyLinks: footerConfig.privacyLinks }), []);
}
